import {
	PROVINCE_FETCH,
	PROVINCE_FETCH_SUCCESS,
	PROVINCE_FETCH_FAIL,
	SUB_PROVINCE_FETCH,
	SUB_PROVINCE_FETCH_SUCCESS,
	SUB_PROVINCE_FETCH_FAIL,
	DISTRICT_FETCH,
	DISTRICT_FETCH_SUCCESS,
	DISTRICT_FETCH_FAIL,

} from '../actions';

const INIT_STATE = {
	provincelist: [],
	subprovincelist: [],
	districtlist: [],
	loading: false,
	error: '',
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case PROVINCE_FETCH:
			return { ...state, loading: true, error: '' };
		case PROVINCE_FETCH_SUCCESS:
			return { ...state, loading: false, provincelist: action.payload, error: '' };
		case PROVINCE_FETCH_FAIL:
			return { ...state, loading: false, provincelist: [], error: action.payload.message };
		case SUB_PROVINCE_FETCH:
			return { ...state, loading: true, error: '' };
		case SUB_PROVINCE_FETCH_SUCCESS:
			return { ...state, loading: false, subprovincelist: action.payload, error: '' };
		case SUB_PROVINCE_FETCH_FAIL:
			return { ...state, loading: false, subprovincelist: [], error: action.payload.message };
		case DISTRICT_FETCH:
			return { ...state, loading: true, error: '' };
		case DISTRICT_FETCH_SUCCESS:
			return { ...state, loading: false, districtlist: action.payload, error: '' };
		case DISTRICT_FETCH_FAIL:
			return { ...state, loading: false, districtlist: [], error: action.payload.message };

		default: return { ...state };
	}
}
